
import { useState, useEffect } from 'react';
import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { optimizeContentfulImage } from '../../utils/imageOptimization';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'; // Include Swiper styles
import 'swiper/css/free-mode';


import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { INLINES } from '@contentful/rich-text-types';

gsap.registerPlugin(ScrollTrigger);



export default function PageCatering() {
    const [cateringData, setCateringData] = useState(null); // Store the relevant fields

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await client.getEntries({ content_type: 'catering' });

                // console.log(response);

                if (response.items.length > 0) {
                    const { albumPhoto01 = [], nomPage, texte, titre, url } = response.items[0].fields;

                    setCateringData({ albumPhoto01, nomPage, texte, titre, url }); // Store only relevant fields
                }
            } catch (error) {
                console.error('Error fetching catering data:', error);
            }
        };

        fetchPage();
    }, []);

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };



    if (!cateringData) {
        return null; // Prevents rendering errors while data is loading
    }

    return (
        <section className="section-catering" data-content-type="catering" id="catering" data-background-color='#c9c4c4;'>
            <div className='inner-container'>


                <div className="phrase">
                    {documentToReactComponents(cateringData.titre, renderOptions)}
                </div>


                <div className='title'>
                    <p >{cateringData.nomPage}</p>
                </div>





                <div className="mySwiperContainer">


                    <Swiper
                        navigation={true}
                        modules={[Navigation, Keyboard, FreeMode]}
                        loop={true}
                        className="mySwiper"
                        keyboard={true}
                        mousewheel={true}
                        spaceBetween={10}
                        slidesPerView={'auto'}
                        freeMode={false}


                    /*           autoplay={{
                                                     delay: 1, // Set a very short delay
                                                     disableOnInteraction: false, // Continue autoplay after user interaction
                                                     waitForTransition: false, // Set to false to immediately proceed to the next slide without waiting for the transition to complete
                                                 }}
                                                 speed={5000} */

                    >
                        {(cateringData.albumPhoto01 ?? [])
                            .filter(photo => photo.fields?.file?.url) // Only include images with a valid URL
                            .map((photo, photoIndex) => (
                                <SwiperSlide key={photoIndex}>
                                    <img
                                        src={optimizeContentfulImage(photo.fields.file.url)}
                                        alt={`Slide ${photoIndex + 1}`}
                                        width={photo.fields.file.details?.image?.width}
                                        height={photo.fields.file.details?.image?.height}
                                    />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>





                <div className="description">
                    {documentToReactComponents(cateringData.texte, renderOptions)}
                </div>

            </div>

        </section>
    );
}
